// extracted by mini-css-extract-plugin
export default {"facilitiesMax":"FacilitiesMax_facilitiesMax__T5Jg8"};